import script from "./Artist.vue?vue&type=script&lang=ts&setup=true"
export * from "./Artist.vue?vue&type=script&lang=ts&setup=true"

import "./Artist.vue?vue&type=style&index=0&id=73dd2158&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73dd2158"]])

export default __exports__